import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { closeAddReclamationDialog } from 'store/common/commonActions';

import ColisLogistiqueQualification from './ColisLogistiqueQualification';

class ColisLogistiqueQualificationContainer extends React.Component {

    render() {
        const { reclamation, colisLogistique, warningSelectionComplete, onAddColis, onRemoveColis, typeAnomalie, closeAddReclamationDialog } = this.props;

        return <ColisLogistiqueQualification
            reclamation={reclamation}
            colisLogistique={colisLogistique}
            closeAddReclamationDialog={closeAddReclamationDialog}
            onAddColis={onAddColis}
            onRemoveColis={onRemoveColis}
            typeAnomalie={typeAnomalie}
            warningSelectionComplete={warningSelectionComplete}
        />;
    }
}

const mapStateToProps = state => ({
    colisLogistique: state.colisLogistique.colisLogistiques.items
});


const mapDispatchToProps = {
    closeAddReclamationDialog,
};

ColisLogistiqueQualificationContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    closeAddReclamationDialog: PropTypes.func.isRequired,
    onAddColis: PropTypes.func.isRequired,
    onRemoveColis: PropTypes.func.isRequired,
    typeAnomalie: PropTypes.number.isRequired,
    warningSelectionComplete: PropTypes.bool
};

ColisLogistiqueQualificationContainer.defaultProps = {
    warningSelectionComplete: false
};

export default connect(mapStateToProps, mapDispatchToProps)(ColisLogistiqueQualificationContainer);